import axios from 'axios'
export default {

    getVentasPorHora(desde, hasta, sucursal = null) {
        let url = `/reportes/ventas/por-hora?desde=${desde}&hasta=${hasta}`;
        if (sucursal && sucursal !== 'all') {
            url += `&sucursal=${sucursal}`;
        }
        return axios.get(url);
    },
    getReporteProductoListado(parametros, headers) {
        var url = `/reportes/reporte/producto/listado`;
        return axios.post(url, parametros, headers)
    },
    getReportePlanillaGondola(parametros, headers) {
        var url = `/reportes/reporte/producto/gondola`;
        return axios.post(url, parametros, headers)
    },
    deleteReporteListaPrecio(id) {
        var url = `/reportes/reporte/producto/listado/${id}`;
        return axios.delete(url)
    },
    getVentasComparativo(anio1, anio2, sucursal = null) {
        let url = `/reportes/ventas/comparativo?anio1=${anio1}&anio2=${anio2}`;
        if (sucursal && sucursal !== 'all') {
            url += `&sucursal=${sucursal}`;
        }
        return axios.get(url);
    },
    getReporteProductosTopTen() {
        var url = "/reportes/reporte/producto/topten";
        return axios.get(url)
    },
    getProductosVendidos(desde, hasta, sucursal = null, orden = "cantidad") {
        let url = `/reportes/ventas/productos?desde=${desde}&hasta=${hasta}&orden=${orden}`;
        if (sucursal && sucursal !== 'all') {
            url += `&sucursal=${sucursal}`;
        }
        return axios.get(url);
    },
    getResumenVentas(desde, hasta, sucursal = null) {
        let url = `/reportes/ventas/resumen?desde=${desde}&hasta=${hasta}`;
        if (sucursal && sucursal !== 'all') {
            url += `&sucursal=${sucursal}`;
        }
        return axios.get(url);
    }
}